import { HealthcareParty, PersonNameUse } from '@icure/cardinal-sdk'

/**
 * Extracts a formatted name from a practitioner object.
 * Falls back to a placeholder if no name is available.
 *
 * Priority order:
 * 1. practitioner.names[0].firstNames + practitioner.names[0].lastName
 * 2. practitioner.firstName + practitioner.lastName
 * 3. practitioner.name
 * 4. Placeholder: 'Practitioner'
 */
export const getPractitionerName = (practitioner?: HealthcareParty, placeholder = 'Practitioner'): string => {
  if (!practitioner) {
    return placeholder
  }

  // Priority 1: Use names array
  if (practitioner.names && practitioner.names.length > 0) {
    const officialNameEntry = practitioner.names.find((name) => name.use === PersonNameUse.Official)

    const nameEntryToBeUsed = officialNameEntry ?? practitioner.names[0]
    const firstNames = nameEntryToBeUsed?.firstNames?.join(' ') || ''
    const lastName = nameEntryToBeUsed?.lastName || ''
    const fullName = `${firstNames} ${lastName}`.trim()
    if (fullName) {
      return fullName
    }
  }

  // Priority 2: Use firstName and lastName
  if (practitioner.firstName || practitioner.lastName) {
    const firstName = practitioner.firstName || ''
    const lastName = practitioner.lastName || ''
    const fullName = `${firstName} ${lastName}`.trim()
    if (fullName) {
      return fullName
    }
  }

  // Priority 3: Use name field if available
  if (practitioner.name) {
    return practitioner.name
  }

  // Fallback to placeholder
  return placeholder
}
